import { PhoneNumInput } from '@ifca-root/react-component/src/components/Input/PhoneNumInput';
import { CommonDialogV2 } from '@ifca-root/react-component/src/components/Dialog/CommonDialogV2';
import { TextField } from '@material-ui/core';
import { isValidPhoneNumber } from 'libphonenumber-js';
import React from 'react';

export type FiuuPatronDetails = {
	patronName: string;
	contactNo: string;
	email: string;
};

interface FiuuOnlinePatronDialogProps {
	open: boolean;
	onClose: () => void;
	patronDetails: FiuuPatronDetails;
	onChange: (field: keyof FiuuPatronDetails, value: string) => void;
	onConfirm: () => void;
	countryCode?: string;
}

const isContactNoValid = (contactNo: string) => {
	if (!contactNo?.trim()) {
		return false;
	}

	const normalized = contactNo.startsWith('+') ? contactNo : `+${contactNo}`;
	return isValidPhoneNumber(normalized);
};

export const FiuuOnlinePatronDialog = ({
	open,
	onClose,
	patronDetails,
	onChange,
	onConfirm,
	countryCode = 'my',
}: FiuuOnlinePatronDialogProps) => {
	const isFormValid =
		patronDetails.patronName?.trim() &&
		patronDetails.email?.trim() &&
		isContactNoValid(patronDetails.contactNo);

	return (
		<CommonDialogV2
			fullWidth={true}
			maxWidth="xs"
			open={open}
			onClose={onClose}
			sections={{
				header: {
					title: 'Online Payment Details',
				},
				body: () => (
					<>
						<TextField
							label="Patron Name"
							value={patronDetails.patronName}
							onChange={e => onChange('patronName', e.target.value)}
							fullWidth
							margin="dense"
							required
							autoComplete="off"
						/>
						<PhoneNumInput
							country={countryCode}
							label="Contact No."
							fullWidth
							value={patronDetails.contactNo}
							onChange={value => onChange('contactNo', value)}
						/>
						<TextField
							label="Email"
							type="email"
							value={patronDetails.email}
							onChange={e => onChange('email', e.target.value)}
							fullWidth
							margin="dense"
							required
							autoComplete="off"
						/>
					</>
				),
				footer: {
					actions: [
						{
							displayText: 'Cancel',
							props: {
								onClick: onClose,
								variant: 'contained',
								color: 'primary',
							},
						},
						{
							displayText: 'Confirm',
							props: {
								onClick: onConfirm,
								variant: 'contained',
								color: isFormValid ? 'primary' : 'inherit',
								disabled: !isFormValid,
							},
						},
					],
				},
			}}
		/>
	);
};
